export const NAME = 'generalSettings/documentSeries';
